
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ['next', 'previous'],
    setup(_, { emit }) {
        const onPrevious = () => emit('previous')
        const onNext = () => emit('next')

        return {
            onPrevious,
            onNext
        }
    }
})
